/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Detect_Overlap_LabelInputs */

const en_style_guide_manager_detect_overlap_label = /** @type {(inputs: Style_Guide_Manager_Detect_Overlap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detect Overlap`)
};

const fr_style_guide_manager_detect_overlap_label = /** @type {(inputs: Style_Guide_Manager_Detect_Overlap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detecter le chevauchement`)
};

const de_style_guide_manager_detect_overlap_label = /** @type {(inputs: Style_Guide_Manager_Detect_Overlap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Überlappung erkennen`)
};

const it_style_guide_manager_detect_overlap_label = /** @type {(inputs: Style_Guide_Manager_Detect_Overlap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rileva sovrapposizione`)
};

const ru_style_guide_manager_detect_overlap_label = /** @type {(inputs: Style_Guide_Manager_Detect_Overlap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обнаружение перекрытия`)
};

const es_style_guide_manager_detect_overlap_label = /** @type {(inputs: Style_Guide_Manager_Detect_Overlap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detectar superposición`)
};

const zh_cn2_style_guide_manager_detect_overlap_label = /** @type {(inputs: Style_Guide_Manager_Detect_Overlap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`检测重叠`)
};

const ja_style_guide_manager_detect_overlap_label = /** @type {(inputs: Style_Guide_Manager_Detect_Overlap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重複を検出`)
};

const hi_style_guide_manager_detect_overlap_label = /** @type {(inputs: Style_Guide_Manager_Detect_Overlap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ओवरलैप का पता लगाएं`)
};

const pt_pt2_style_guide_manager_detect_overlap_label = /** @type {(inputs: Style_Guide_Manager_Detect_Overlap_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detectar sobreposição`)
};

/**
* | output |
* | --- |
* | "Detect Overlap" |
*
* @param {Style_Guide_Manager_Detect_Overlap_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_detect_overlap_label = /** @type {((inputs?: Style_Guide_Manager_Detect_Overlap_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Detect_Overlap_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_detect_overlap_label(inputs)
	if (locale === "de") return de_style_guide_manager_detect_overlap_label(inputs)
	if (locale === "it") return it_style_guide_manager_detect_overlap_label(inputs)
	if (locale === "ru") return ru_style_guide_manager_detect_overlap_label(inputs)
	if (locale === "es") return es_style_guide_manager_detect_overlap_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_detect_overlap_label(inputs)
	if (locale === "ja") return ja_style_guide_manager_detect_overlap_label(inputs)
	if (locale === "hi") return hi_style_guide_manager_detect_overlap_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_detect_overlap_label(inputs)
	return en_style_guide_manager_detect_overlap_label(inputs)
});